<template>
  <v-dialog v-model="sendDDMandateOpen" width="400" @click:outside="close">
    <v-card>
      <v-card-title>Send DD Mandate</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            Are you sure you wish to send the DD Mandate?
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="sendDDMandateLoading" :loading="sendDDMandateLoading">SEND</v-btn>
        <v-btn color="primary" small outlined @click="close">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState,mapActions,mapMutations } from "vuex";
  export default {
    computed: {
      ...mapState('leads', ['currentLead','sendDDMandateOpen','sendDDMandateLoading']),
    },
    methods: {
      ...mapActions('leads', ['sendDDMandate']),
      ...mapMutations('leads',['setSendDDMandateOpen']),
      async submit() {
        await this.sendDDMandate(this.currentLead.account_id);
      },
      close() {
        this.setSendDDMandateOpen(false);
      },
    },
  }
</script>

<style lang="scss" scoped></style>
